import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/mini_programs', { params })
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/mini_programs/${id}/attribute`, params)
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const qrcode = (id: number, params = {}): AxiosPromise => {
  return axios.get(`/mini_programs/${id}/qrcode`, { params })
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/mini_programs/${id}`)
}
